// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import AadharDetailsActionType from './aadhar-details.types';

const INITIAL_STATE = {
	// Aadhar Front Image
	aadharFrontImage: '',
	// Aadhar Back Image
	aadharBackImage: '',
	// Update Aadhar Response
	updateAadharResponse: null,
	// Aadhar OTP Response
	aadharOtpResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** AADHAR FRONT AND BACK IMAGE CHANGED ************************/
		case AadharDetailsActionType.AADHAR_FRONT_IMAGE_CHANGED:
			return { ...state, aadharFrontImage: action.payload };

		case AadharDetailsActionType.AADHAR_BACK_IMAGE_CHANGED:
			return { ...state, aadharBackImage: action.payload };
		/** ***************** AADHAR FRONT AND BACK IMAGE CHANGED ************************/

		/** ***************** UPDATE AADHAR START *********************** */
		case AadharDetailsActionType.UPDATE_AADHAR_SUCCESS:
			return { ...state, updateAadharResponse: action.payload };

		case AadharDetailsActionType.UPDATE_AADHAR_FAILURE:
			return { ...state, updateAadharResponse: action.payload };

		case AadharDetailsActionType.UPDATE_AADHAR_RESPONSE_CHANGED:
			return { ...state, updateAadharResponse: null };
		/** ***************** UPDATE AADHAR END *********************** */

		/** ***************** AADHAR OTP START *********************** */
		case AadharDetailsActionType.SEND_AADHAR_OTP_SUCCESS:
			return { ...state, aadharOtpResponse: action.payload };

		case AadharDetailsActionType.SEND_AADHAR_OTP_FAILURE:
			return { ...state, aadharOtpResponse: action.payload };

		case AadharDetailsActionType.SEND_AADHAR_OTP_RESPONSE_CHANGED:
			return { ...state, aadharOtpResponse: null };
		/** ***************** AADHAR OTP END *********************** */
		default:
			return state;
	}
};
